import { fetchAll, fetchFiltered, add, edit, show } from '@/api/company'

const state = {
  all: [],
  isLoading: false,
  companyById: null
}

const getters = {}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const company = await show(id)
      commit('setCompanyById', company)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const companies = await fetchAll()
      commit('setAll', companies)
    } catch (e) {
      dispatch('notify/success', e.message, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const companies = await fetchFiltered(queriesParams)
      commit('setAll', companies)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, user) {
    commit('setLoading', true)
    try {
      await add(user)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.companyById = null
  },

  setCompanyById (state, company) {
    const { name, id, systemmodules } = company
    state.companyById = { name, id, systemmodules }
  },

  setAll (state, companies) {
    state.all = companies
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
